<template>
    <div>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-group">

                    <label class="generic-label">Call Date</label>

                    <br>

                    <div class="core-radio-group">
                        <div class="core-radio">
                            <input id="radio1" name="option" type="radio" v-model="future" :value="false" @click="isFuture(false)" :disabled="readOnly">
                            <label for="radio1">A.S.A.P.</label>
                        </div>

                        <div class="core-radio">
                            <input id="radio2" name="option" type="radio" v-model="future" :value="true" @click="isFuture(true)" :disabled="readOnly">
                            <label for="radio2">Future</label>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
<!--                This is suppose to show the date and time in the input but I could only get the date to show, when you click on the date it shows a time-->
<!--                Currently the date is disabled because future radio button is not selected-->
                <div class="form-group">
                    <label class="generic-label" for="future_datetime">Future Date/Time</label>
                    <div class="input-group">
                        <date-range-picker v-model="holdDate"
                                           :range="false"
                                           :time="true"
                                           :disabled="!future"
                                           @change="holdDateChange"
                                           format="MM/DD/YYYY h:mm a"
                                           :readonly="readOnly"
                        ></date-range-picker>
                        <label class="input-group-addon btn" for="future_datetime">
                            <span class="fas fa-calendar-alt"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                <div class="form-group" :class="{required: requiredFields.PONumber === true}">
                    <label class="generic-label" for="club_po">Club/PO #</label>
                    <input id="club_po" name="club_po" maxlength="40" type="text" placeholder="Club/PO #" class="form-control generic-input" v-model="call.PONumber" :readonly="readOnly" v-uppercase>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group" :class="{required: requiredFields.Location === true, error: fieldErrors.Location === true}">
                    <label class="generic-label" for="txtLocation">Location</label>
                    <address-autocomplete v-model="call.Location" @change="locationChanged" @location="locationSelected" :readonly="readOnly"></address-autocomplete>
                    <div class="error" v-if="fieldErrors.Location === true">The location field is required.</div>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group" :class="{required: requiredFields.Destination === true}">
                    <label class="generic-label" for="txtDestination">Destination</label>
                    <address-autocomplete v-model="call.Destination" @change="destinationChanged" @location="destinationSelected" :readonly="readOnly"></address-autocomplete>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

    import AddressAutocomplete from '../AddressAutocomplete';

    export default {

        components: {
            AddressAutocomplete,
        },

        props: {
            call: Object,
            requiredFields: Object,
            fieldErrors: Object,
            readOnly: Boolean,
        },

        data() {
            return {
                future: false,
                holdDate: '',
            }
        },

        mounted() {

            if (this.call.HoldDate) {
                this.holdDate = moment(this.call.HoldDate, 'MM/DD/Y h:mm a');
                this.isFuture(true);
            } else {
                this.holdDate = moment().add(2, 'hour').startOf('hour');
                this.isFuture(false);
            }

        },

        methods: {

            isFuture(future) {
                this.future = (future === true);
                this.call.HoldDate = (this.future ? this.holdDate : null);
            },

            holdDateChange(holdDate) {
                this.call.HoldDate = holdDate;
            },

            locationChanged() {
                if (!this.readOnly) {
                    this.call.LocationLatitude  = 0;
                    this.call.LocationLongitude = 0;
                }
            },

            destinationChanged() {
                if (!this.readOnly) {
                    this.call.DestinationLatitude  = 0;
                    this.call.DestinationLongitude = 0;
                }
            },

            locationSelected(location) {
                if (!this.readOnly) {
                    this.$nextTick(() => {  // Make sure locationChanged() doesn't override content
                        this.call.LocationLatitude  = location.coords.lat;
                        this.call.LocationLongitude = location.coords.lng;
                    });
                }
            },

            destinationSelected(location) {
                if (!this.readOnly) {
                    this.$nextTick(() => { // Make sure destinationChanged() doesn't override content
                        this.call.DestinationLatitude  = location.coords.lat;
                        this.call.DestinationLongitude = location.coords.lng;
                    });
                }
            },

        }

    }
</script>

